// ============================================================
// Aitrack — configurazione announcement bar (banner promozionale
// sopra l'header, stile "announcement bar" degli store Shopify:
// barra sottile, full-width, cliccabile, chiudibile singolarmente).
//
// COME AGGIUNGERE UN NUOVO BANNER (senza toccare AnnouncementBanner.jsx):
//
//   1. Aggiungi i testi in src/i18n/locales/it.json e en.json, sotto la
//      chiave "announcements", con un nuovo blocco per il tuo <id>:
//
//        "announcements": {
//          ...
//          "promo2027": {
//            "before": "Testo prima del codice",
//            "code": "PROMO27",              // vuoto "" se non serve un codice in evidenza
//            "after": "Testo dopo il codice, condizioni, scadenza."
//          }
//        }
//
//   2. Aggiungi una entry qui sotto in ANNOUNCEMENTS:
//
//        {
//          id: 'promo2027',                    // univoco: entra nella chiave di dismiss in
//                                               // localStorage, così il banner nuovo riappare
//                                               // anche a chi aveva chiuso quello precedente
//          from: '2027-01-01T00:00:00',        // inizio validità, ora locale Europe/Rome
//          to:   '2027-03-31T23:59:59',        // fine validità, ora locale Europe/Rome
//          textKey: 'announcements.promo2027', // namespace i18n del punto 1
//          href: '/contact',                   // percorso relativo o URL assoluto
//          target: 'site',                     // 'site' localizza IT/EN; default = AUTH_URL
//          bg: 'var(--brand)',                 // opzionale, default = blu brand
//        }
//
//   3. Fatto: zero modifiche al componente. Alla prossima build il banner
//      giusto appare da solo quando la data corrente rientra in [from, to]
//      (orario Europe/Rome). Se più banner risultano attivi insieme vince
//      il primo dell'array.
// ============================================================

export const ANNOUNCEMENTS = [
  {
    id: 'lancio2026',
    from: '2026-01-01T00:00:00',
    to: '2026-12-31T23:59:59',
    textKey: 'announcements.lancio2026',
    href: '/contact',
    target: 'site',
    bg: 'var(--brand)',
  },
];

/**
 * Istante corrente come stringa "YYYY-MM-DDTHH:mm:ss" nel fuso Europe/Rome,
 * comparabile lessicograficamente con from/to: evita l'ambiguità del parsing
 * di stringhe di data senza offset (che JS interpreta nel fuso del browser,
 * non necessariamente quello italiano).
 */
function romeNowString() {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Rome',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(new Date());
  const get = (type) => parts.find((p) => p.type === type)?.value ?? '00';
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`;
}

export function isAnnouncementActive(announcement, nowString = romeNowString()) {
  const { from, to } = announcement;
  return (!from || nowString >= from) && (!to || nowString <= to);
}

/** Primo banner attivo per data (Europe/Rome), o null se nessuno lo è. */
export function getActiveAnnouncement() {
  const now = romeNowString();
  return ANNOUNCEMENTS.find((a) => isAnnouncementActive(a, now)) || null;
}
